<template>
    <v-container fluid>
        <!-- Project name -->
        <v-col>
            <v-row class="pl-4 headline">
                {{ item.title }}
            </v-row>
        </v-col>
        
        
        <v-row class="pl-4 pr-4 pt-3">

            <!-- COLUMN 1 -->
            <v-col cols="3">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- SOURCE -->
                        <span v-if="item.source !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-source'"
                            >{{ $t('lang_GENERIC_CAPTION_SOURCE') }}:</div>
                            <div :alvqa="alvqa + '-source'" class="pb-2">
                                {{ getSourceName(item.source) }}
                            </div>
                        </span>
                        <!-- DOMAIN -->
                        <span v-if="item.domain !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-domain'"
                            >{{ $t('lang_ACCOUNT_MAPPINGS_CAPTION_DOMAINS') }}:</div>
                            <div :alvqa="alvqa + '-domain'" class="pb-2">
                                {{ getDomainName(item.domain) }}
                            </div>
                        </span>
                        <!-- DIRECTION -->
                        <span v-if="item.direction !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-direction'"
                            >{{ $t('lang_ACCOUNT_MAPPINGS_CAPTION_DIRECTIONS') }}:</div>
                            <div :alvqa="alvqa + '-direction'" class="pb-2">
                                {{ getDirectionName(item.direction) }}
                            </div>
                        </span>
                        <!-- SHAREABLE -->
                        <span v-if="item.shareable !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-shareable'"
                            >{{ $t('lang_GENERIC_CAPTION_SHAREABILITY') }}:</div>
                            <div :alvqa="alvqa + '-shareable'" class="pb-2">
                                {{ getShareableName(item.shareable) }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- COLUMN 2 -->
            <v-col cols="4">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- ALVID -->
                        <span v-if="item.alvId !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-alvid'"
                            >{{ $t('lang_GENERIC_CAPTION_ALVID') }}:</div>
                            <div :alvqa="alvqa + '-alvid'" class="pb-2">
                                {{ item.alvId }}
                            </div>
                        </span>
                        <!-- MAINTAINER -->
                        <span v-if="item.maintainer !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-maintainer'"
                            >{{ $t('lang_ACCOUNT_MAPPINGS_CAPTION_MAINTAINERS') }}:</div>
                            <div :alvqa="alvqa + '-maintainer'" class="pb-2">
                                {{ item.maintainer }}
                            </div>
                        </span>
                        <span v-if="item.language !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-language'"
                            >{{ $t('lang_GENERIC_CAPTION_LANGUAGE') }}:</div>
                            <div :alvqa="alvqa + '-language'" class="pb-2">
                                {{ $t(languageText) }}
                            </div>
                        </span>
                        <!-- VERSION NUMBER -->
                        <!-- <span v-if="item.versionNumber !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-version-number'"
                            >{{ $t('lang_GENERIC_CAPTION_VERSION_NUMBER') }}:</div>
                            <div :alvqa="alvqa + '-version-number'" class="pb-2">
                                {{ item.versionNumber }}
                            </div>
                        </span> -->
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- COLUMN 3 -->
            <v-col cols="2">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- ABBREVIATION -->
                        <span v-if="item.abbreviation !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-abbreviation'"
                            >{{ $t('lang_GENERIC_CAPTION_ABBREVIATION') }}:</div>
                            <div :alvqa="alvqa + '-abbreviation'" class="pb-2">
                                {{ item.abbreviation }}
                            </div>
                        </span>
                        <!-- FILE FORMAT -->
                        <span v-if="item.fileFormat !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-file-format'"
                            >{{ $t('lang_GENERIC_CAPTION_FILE_FORMAT') }}:</div>
                            <div :alvqa="alvqa + '-file-format'" class="pb-2">
                                {{ getFileFormat(item.fileFormat) }}
                            </div>
                        </span>
                        <!-- DECIMAL SEPARATOR -->
                        <span v-if="item.decimalSeparator !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-decimal-separator'"
                            >{{ $t('lang_GENERIC_CAPTION_DECIMAL_SEPARATOR') }}:</div>
                            <div :alvqa="alvqa + '-decimal-separator'" class="pb-2">
                                {{ getDecimalSeparator(item.decimalSeparator) }}
                            </div>
                        </span>
                        <!-- CURRENCY -->
                        <span v-if="item.currency !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-currency'"
                            >{{ $t('lang_GENERIC_CAPTION_CURRENCY') }}:</div>
                            <div :alvqa="alvqa + '-currency'" class="pb-2">
                                {{ item.currency }}
                            </div>
                        </span>
                        <!-- RIGHTS TYPE -->
                        <!-- <span v-if="item.rightsType !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-rights-type'"
                            >{{ $t('lang_GENERIC_CAPTION_RIGHTS_TYPE') }}:</div>
                            <div :alvqa="alvqa + '-rights-type'" class="pb-2">
                                {{ getRightsType(item.rightsType) }}
                            </div>
                        </span> -->
                    </v-card-text>
                </v-card>
            </v-col>

            <!-- COLUMN 4 -->
            <v-col cols="3">
                <v-card elevation="0">
                    <v-card-text>
                        <!-- FILE -->
                        <span v-if="item.fileName !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-abbreviation'"
                            >{{ $t('lang_ACCOUNTS_MAPPINGS_CAPTION_TEMPLATE_PANEL') }}:</div>
                            <div :alvqa="alvqa + '-abbreviation'" class="pb-2">
                                {{ item.fileName }}
                            </div>
                        </span>
                        <!-- SHEET -->
                        <span v-if="item.sheet !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-sheet'"
                            >{{ $t('lang_ACCOUNT_MAPPINGS_CAPTION_SHEET') }}:</div>
                            <div :alvqa="alvqa + '-sheet'" class="pb-2">
                                {{ item.sheet }}
                            </div>
                        </span>
                        <!-- HEADER ROW -->
                        <span v-if="item.headerRow !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-header-row'"
                            >{{ $t('lang_ACCOUNT_MAPPINGS_CAPTION_HEADER_ROW') }}:</div>
                            <div :alvqa="alvqa + '-header_row'" class="pb-2">
                                {{ item.headerRow }}
                            </div>
                        </span>
                        <!-- DATA ROW -->
                        <span v-if="item.dataRow !== null">
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-data-row'"
                            >{{ $t('lang_ACCOUNT_MAPPINGS_CAPTION_DATA_ROW') }}:</div>
                            <div :alvqa="alvqa + '-data-row'" class="pb-2">
                                {{ item.dataRow }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <!-- NOTES -->
        <v-row v-if="item.notes !== null" class="pl-4 pr-4">
            <v-col cols="12">
                <v-card  elevation="0">
                    <v-card-text>
                        <span>
                            <div
                                class="read-only-caption"
                                :alvqa="alvqa + '-caption-notes'"
                            >{{ $t('lang_GENERAL_CAPTION_NOTES') }}:</div>
                            <div :alvqa="alvqa + '-notes'" class="pb-2">
                                {{ item.notes }}
                            </div>
                        </span>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col class="ml-4 mr-4">
                <v-expansion-panels multiple focusable tile flat>
                    <ColumnMappingsReadOnlyPanel :mappingsAlvId="item.alvId" />
                    <TemplateReadOnlyPanel :mappingsAlvId="item.alvId" />
                </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import ColumnMappingsReadOnlyPanel from './_panels/1_columns/ColumnMappingsReadOnlyPanel'
import TemplateReadOnlyPanel from './_panels/3_template/TemplateReadOnlyPanel'
import BaseTooltip from '@/components/_base/BaseTooltip'
import 
    { 
        DropdownAccountMappingsDirectionsOptions,
        DropdownAccountMappingsDomainsOptions,
        DropdownAccountMappingsDecimalSeparatorOptions,
        DropdownGenericYesNo,
        DropdownAccountMappingsPublishingRightsTypes,
    } 
from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "MappingsReadOnly",
    components: {
        ColumnMappingsReadOnlyPanel,
        TemplateReadOnlyPanel,
        BaseTooltip,
    },
    props: {
        itemId: {
            type: Number
        }
    },
    data() {
        return {
            alvqa: 'account-mappings-list-row-' + this.itemId + '-read-only',
            languagesList: JSON.parse(JSON.stringify(this.$store.getters.getGeneralLanguages))
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedMappings.find(element => {
                return element.id === this.itemId
            })
            return item
        },
        languageText() {
            let match = this.languagesList.find(lang => { return lang.value === this.item.language })
            return match ? match.text : ''
        }
    },
    methods: {
        getSourceName(sourceValue) { // contains ALVID of A-Z Society or Distributor
            let direction = this.$store.getters.getMappingsDetailsDirection 
            let AzList = (direction == "import") ? this.$store.getters.getAzForMappingsImport : this.$store.getters.getAzForMappingsExport
            let match = AzList.find(type => { return type.value === sourceValue })
            if(match !== undefined) return match.text 
            else return ''
        },
        getDomainName(domainValue) { // i.e. lang constant for Publishing > Income
            let match = DropdownAccountMappingsDomainsOptions.find(type => { return type.value === domainValue })
            if(match !== undefined) return this.$t(match.text) 
            else return ''
        },
        getDirectionName(directionValue) { // i.e. lang constant for Publishing > Income
            let match = DropdownAccountMappingsDirectionsOptions.find(type => { return type.value === directionValue })
            if(match !== undefined) return this.$t(match.text) 
            else return ''
        },
        getShareableName(shareableValue) { // i.e. lang constant for Publishing > Income
            let match = DropdownGenericYesNo.find(type => { return type.value === shareableValue })
            if(match !== undefined) return this.$t(match.text) 
            else return ''
        },
        getDecimalSeparator(separatorValue) { // i.e. lang constant for Publishing > Income
            let match = DropdownAccountMappingsDecimalSeparatorOptions.find(type => { return type.value === separatorValue })
            if(match !== undefined) return this.$t(match.text) 
            else return ''
        },
        getRightsType(typeValue) { // i.e. lang constant for Publishing > Income
            let match = DropdownAccountMappingsPublishingRightsTypes.find(type => { return type.value === typeValue })
            if(match !== undefined) return this.$t(match.text) 
            else return ''
        },
        getFileFormat(format) {
            return format.toUpperCase()
        }
        
    },

}
</script>

                        